(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gm-newsletter"] && !Shopify.designMode) return;
  try {
    
  const footerDesktop = window.matchMedia('(min-width: 750px)');
  const syncFooterMenus = () => {
    document.querySelectorAll('.gm-footer-menu').forEach((menu) => {
      menu.open = footerDesktop.matches;
      menu.querySelector('summary').tabIndex = footerDesktop.matches ? -1 : 0;
    });
  };
  syncFooterMenus();
  footerDesktop.addEventListener('change', syncFooterMenus);
  document.addEventListener('shopify:section:load', syncFooterMenus);
  document.addEventListener('click', (event) => {
    if (footerDesktop.matches && event.target.closest('.gm-footer-menu > summary')) {
      event.preventDefault();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
